import React from 'react';
import { PermissionGenericErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/permission-generic-error-boundary/index.tsx';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import SpaErrorBoundary from '@atlassian/jira-spa-apps-common/src/error-boundary';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import TrashedProjectsDirectory from '@atlassian/jira-trashed-projects-main/src/ui/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment';
import { trashedProjectsPageLoad } from './utils/performance-analytics';

const APP_NAME = 'trashed-projects';
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<UFOSegment name="trashed-projects">
		<MarkProductStart />
		<SpaErrorBoundary id="spa-app-bootstrap.directories.trashed-projects">
			<PermissionGenericErrorBoundary>
				<TrashedProjectsDirectory />
				{/* @ts-expect-error - TS2769 - No overload matches this call. */}
				<SubmitApdex appName={APP_NAME} metric={trashedProjectsPageLoad} />
			</PermissionGenericErrorBoundary>
		</SpaErrorBoundary>
	</UFOSegment>
);
